// import firebase from '../../config-firebase/firebase'
import { database, databaseShared } from "../../config-firebase/firebase";
import {
  ref,
  child,
  get,
  set,
  off,
  onValue,
  onChildAdded,
  limitToLast,
  onDisconnect,
  query,
  orderByKey,
  endAt,
  runTransaction,
  update,
  push,
  remove,
  serverTimestamp,
} from "firebase/database";
import authentication from "./auth";
import store from "../store";
import * as types from "../store/mutations-types";
import EventEmitter from "events";
import Constants from "./constants";
import Config from "../../config-app/config";
import { ErrorAstaNotFound, ErrorSessionExist } from "./errors";
import * as Helpers from "./helpers";
import * as Utils from "./utils";
import { lte } from "lodash";
import { validateRosaLimits } from "./rosaLimits";

const versionRef = ref(databaseShared, "version");
const calciatoriRef = ref(databaseShared, "calciatori");
// const listoneConfRef = ref(databaseShared, "listone-conf");
const userAstaRef = ref(databaseShared, "user-asta");
const astaBasicRef = ref(databaseShared, "asta-basic");

let astaRef = ref(database, "asta");
let astaPassRef = ref(database, "asta-pass");
let passAstaRef = ref(database, "pass-asta");
let astasquadreRef = ref(database, "asta-squadre");
let astaroundRef = ref(database, "asta-round");
let astaonlineRef = ref(database, "asta-online");
let astamessagesRef = ref(database, "asta-messages");
let astaLogsRef = ref(database, "asta-logs");
let astascartatiRef = ref(database, "asta-scartati");
let astaCuoriRef = ref(database, "asta-cuori");
let legheRef = ref(database, "leghe");
let connectedRef = ref(database, ".info/connected");
let calciatoriCustomRef = ref(database, "asta-calciatori-custom");

class Asta extends EventEmitter {
  constructor() {
    super();
  }

  // è un duplicato di quello in mixins
  wait(ms) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve();
      }, ms);
    });
  }

  generatePassword(prefix, separator = "-", length = 8) {
    const safeChars =
      "abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let password = "";

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * safeChars.length);
      password += safeChars[randomIndex];
    }

    return prefix + separator + password;
  }

  getVersion() {
    return get(versionRef).then((snapshot) => {
      let version = snapshot.val();
      return version;
    });
  }

  async createAstaESquadra(
    astaName,
    uid,
    maxSquadre,
    creditiLega,
    nP,
    nD,
    nC,
    nA,
    nomeSquadra,
    picSquadra,
    mode,
    tipoRuoli
  ) {
    // generate new key
    const asta_id = push(astaRef).key;

    // init all needed values
    let astaInfo = {
      name: astaName,
      admin: uid,
      lega: {
        maxSquadre: maxSquadre,
        crediti: creditiLega,
        nRuoli: {
          nP: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nP : -1,
          nD: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nD : -1,
          nC: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nC : -1,
          nA: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? nA : -1,
          op: tipoRuoli == Constants.TIPO_RUOLI.CLASSIC ? "=" : "illimitati",
        },
      },
      settings: {
        mode: mode,
        tipo_ruoli: tipoRuoli,
      },
    };
    astaInfo = this.initAstaInfo(asta_id, astaInfo);

    let astaBasic = this.initAstaBasic();

    // pass x invito (uso asta_id come prefix solo per garantire unicità della pass)
    const pass = this.generatePassword(asta_id);

    try {
      // 1) add to user-aste (è importante che sia al primo posto perchè le db rules di lista-aste si basano su questa)
      await this.addAstaToUser(Config.ANNO_ID, uid, Config.TORNEO_ID, asta_id);

      // 2) add to astaBasic
      await this.addToAstaBasic(
        Config.TORNEO_ID,
        Config.ANNO_ID,
        asta_id,
        astaBasic
      );

      // 3) create astaInfo
      await this.createAstaInfo(asta_id, astaInfo);

      // 4) pass
      await this.addAstePass(asta_id, pass);
      await this.addPassAsta(pass, asta_id);

      // 5) create squadra
      await this.createSquadra(
        asta_id,
        uid,
        nomeSquadra,
        picSquadra,
        creditiLega
      );
    } catch (error) {
      throw new Error(error.message);
    }

    return asta_id;
  }

  getAstaInfo(asta_id) {
    return get(child(astaRef, asta_id)).then((snapshot) => {
      let asta = snapshot.val();
      if (!asta) {
        throw new ErrorAstaNotFound("Asta " + asta_id + " non trovata");
      }
      return asta;
    });
  }

  getAstaPass(asta_id) {
    return get(child(astaPassRef, asta_id)).then((snapshot) => {
      return snapshot.val() || null;
    });
  }

  getAstaIdByPass(pass) {
    return get(child(passAstaRef, pass)).then((snapshot) => {
      return snapshot.val();
    });
  }

  initAstaInfo(asta_id, _astaInfo = {}) {
    let astaInfo = {};
    astaInfo.id = asta_id;
    astaInfo.eliminazioniSquadre = _astaInfo.eliminazioniSquadre || null;
    const ID_Divisione = parseInt(`${asta_id}`.split("_")[1]) || 0;

    astaInfo.name =
      _astaInfo && _astaInfo.name !== undefined ? _astaInfo.name : "";
    astaInfo.admin =
      _astaInfo && _astaInfo.admin !== undefined
        ? _astaInfo.admin
        : Constants.NO_ADMIN;
    astaInfo.counter =
      _astaInfo && _astaInfo.counter !== undefined
        ? _astaInfo.counter
        : Constants.NUM_ASSEGNAZIONI_FREE;
    astaInfo.premium =
      _astaInfo && _astaInfo.premium !== undefined ? _astaInfo.premium : 0;
    astaInfo.statoMercato =
      _astaInfo && _astaInfo.statoMercato !== undefined
        ? _astaInfo.statoMercato
        : 1;
    if (!Config.STANDALONE) {
      astaInfo.adminPermission =
        _astaInfo && _astaInfo.adminPermission !== undefined
          ? _astaInfo.adminPermission
          : Constants.ADMIN_PERMISSION.ANYONE;
    }

    // astaInfo.squadra = false;
    astaInfo.settings = {
      tipo_ruoli:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.tipo_ruoli !== undefined
          ? _astaInfo.settings.tipo_ruoli
          : Constants.TIPO_RUOLI.CLASSIC,

      status:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.status !== undefined
          ? _astaInfo.settings.status
          : Constants.ASTA_STATUS.NOT_RUNNING,

      mode:
        _astaInfo && _astaInfo.settings && _astaInfo.settings.mode !== undefined
          ? _astaInfo.settings.mode
          : Constants.ASTA_MODE.SELVAGGIA,

      timeout_c:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.timeout_c !== undefined
          ? _astaInfo.settings.timeout_c
          : 30,

      timeout_s:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.timeout_s !== undefined
          ? _astaInfo.settings.timeout_s
          : 30,

      ch_mode:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.ch_mode !== undefined
          ? _astaInfo.settings.ch_mode
          : Constants.CHOOSER_MODE.MANUAL,

      random_mode:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.random_mode !== undefined
          ? _astaInfo.settings.random_mode
          : Constants.RANDOM_MODE.DISABLED,

      base_asta:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.base_asta !== undefined
          ? _astaInfo.settings.base_asta
          : Constants.BASE_ASTA.UNO,

      offerta_auto:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.offerta_auto !== undefined
          ? _astaInfo.settings.offerta_auto
          : Constants.OFFERTA_AUTO.ENABLED,

      ruolo_da_chiamare:
        _astaInfo &&
        _astaInfo.settings &&
        _astaInfo.settings.ruolo_da_chiamare !== undefined
          ? _astaInfo.settings.ruolo_da_chiamare
          : Constants.RUOLO_DA_CHIAMARE.QUALUNQUE,
    };

    // qui o le passo tutte in _astaInfo.lega o nessuna => nn c'è bisogno di fare i check a uno a uno
    astaInfo.lega = _astaInfo.lega || {
      maxSquadre: 8,
      crediti: 500,
      nRuoli: {
        nP: 3,
        nD: 8,
        nC: 8,
        nA: 6,
        op: "=",
      },
      // questi 2 nn ho testato se posso farne a meno di inizializzarli
      usaTuttoBudget: 0,
      limitRosaPerClub: {
        activeMode: "no",
      },
    };
    astaInfo.lega.ID_Divisione = ID_Divisione;
    return astaInfo;
  }

  initAstaBasic() {
    let astaBasic = {};
    astaBasic.table_num = Config.TABLE_NUM_DEFAULT;
    return astaBasic;
  }

  fetchAstaInfo() {
    let id = store.getters.asta_id;
    off(child(astaRef, id));
    onValue(child(astaRef, id), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ASTA_UPD, _val);
    });

    off(child(astaRef, id + "/counter"));
    onValue(child(astaRef, id + "/counter"), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ASTA_UPD, {
        counter: _val,
      });
      this.emit("counter", _val);
    });

    off(child(astaRef, id + "/settings/status"));
    onValue(child(astaRef, id + "/settings/status"), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.SETTINGS_UPD, {
        status: _val,
      });
      this.emit("status", _val);
    });
  }

  fetchLegaInfo() {
    let ID_Lega = store.getters.asta_info && store.getters.asta_info.lega
      ? store.getters.asta_info.lega.ID_Lega
      : null;

    if (!ID_Lega) {
      store.commit(types.ASTA_LEGA_INFO_SET, {});
      return;
    }

    off(child(legheRef, ID_Lega));
    onValue(child(legheRef, ID_Lega), (snapshot) => {
      store.commit(types.ASTA_LEGA_INFO_SET, snapshot.val() || {});
    });
  }

  createAstaInfo(asta_id, astaInfo) {
    return set(child(astaRef, asta_id), astaInfo);
  }

  addAstePass(asta_id, pass) {
    return set(child(astaPassRef, asta_id), pass);
  }

  addPassAsta(pass, asta_id) {
    return set(child(passAstaRef, pass), asta_id);
  }

  createSquadra(asta_id, uid, nomeSquadra, picSquadra, crediti) {
    return set(child(astasquadreRef, asta_id + "/" + uid), {
      name: nomeSquadra,
      crediti: crediti,
      pic: picSquadra,
      calciatori: {},
    });
  }

  updateNomeSquadra(asta_id, uid, nome) {
    return update(child(astasquadreRef, asta_id + "/" + uid), {
      name: nome,
    });
  }

  async eliminaSquadra(squadraId) {
    if (!Config.STANDALONE) throw new Error("Operazione disponibile solo in standalone.");
    const astaId = store.getters.asta_id;
    const uid = authentication.getUserId();
    const [info, squadraSnapshot, roundSnapshot] = await Promise.all([
      this.getAstaInfo(astaId),
      get(child(astasquadreRef, astaId + "/" + squadraId)),
      get(child(astaroundRef, astaId)),
    ]);
    const squadra = squadraSnapshot.val();
    const round = roundSnapshot.val() || {};
    const reason = Helpers.eliminaSquadraDisabledReason(
      Config.STANDALONE, uid, info, round, squadraId, squadra
    );
    if (reason) throw new Error(reason);

    const count = info.eliminazioniSquadre ? info.eliminazioniSquadre.count : 0;
    const logId = push(child(astaLogsRef, astaId)).key;
    // Le regole accettano cancellazione e contatore soltanto insieme.
    const updates = {
      [`asta-squadre/${astaId}/${squadraId}`]: null,
      [`asta-cuori/${astaId}/${squadraId}`]: null,
      [`asta-online/${astaId}/${squadraId}`]: null,
      [`user-asta/${Config.ANNO_ID}/${squadraId}/${Config.TORNEO_ID}/${astaId}`]: null,
      [`asta/${astaId}/eliminazioniSquadre`]: { count: count + 1, squadraId },
      [`asta-logs/${astaId}/${logId}`]: {
        t: Constants.LOG_TYPE.SQUADRA_ELIMINATA,
        sid: squadraId,
        sn: squadra.name,
        ts: serverTimestamp(),
      },
      [`asta-round/${astaId}/offerte/${squadraId}`]: null,
      [`asta-round/${astaId}/offerte_ts/${squadraId}`]: null,
    };
    if (round.chooser === squadraId) updates[`asta-round/${astaId}/chooser`] = null;
    if (round.speaker === squadraId) {
      updates[`asta-round/${astaId}/speaker`] = null;
      updates[`asta-round/${astaId}/speakerTimeLeft`] = null;
    }
    await update(ref(database), updates);
  }

  updatePicSquadra(asta_id, uid, pic) {
    return update(child(astasquadreRef, asta_id + "/" + uid), {
      pic: pic,
    });
  }

  updateAdmin(uid) {
    let asta_id = store.getters.asta_id;
    return update(child(astaRef, asta_id), {
      admin: uid,
    });
  }

  updateAdminAndPermission(uid, adminPermission) {
    let asta_id = store.getters.asta_id;
    return update(child(astaRef, asta_id), {
      admin: uid,
      adminPermission: adminPermission,
    });
  }

  updateAdminPermission(adminPermission) {
    let asta_id = store.getters.asta_id;
    return update(child(astaRef, asta_id), {
      adminPermission: adminPermission,
    });
  }

  setOrdineSquadra(id_squadra, order) {
    let asta_id = store.getters.asta_id;
    return set(
      child(astasquadreRef, asta_id + "/" + id_squadra + "/order"),
      order
    );
  }

  setActiveSquadra(id_squadra, active) {
    let asta_id = store.getters.asta_id;
    return set(
      child(astasquadreRef, asta_id + "/" + id_squadra + "/active"),
      active
    );
  }

  fetchSquadre() {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    if (asta_id) {
      off(child(astasquadreRef, asta_id));
      onValue(child(astasquadreRef, asta_id), (snapshot) => {
        // verifico esistenza mia squadra
        let _squadre = snapshot.val() || {};

        let sq_exists = false;
        for (let s in _squadre) {
          sq_exists = sq_exists || s == user_uid;
        }
        store.commit(types.SQUADRE_SET, _squadre);
        if (Config.STANDALONE && !_squadre[store.getters.selected_squadra]) {
          store.commit(types.SQUADRE_SEL, sq_exists ? user_uid : Object.keys(_squadre)[0] || null);
        }
        store.commit(types.ASTA_UPD, {
          squadra: sq_exists,
        });
      });
    }
  }

  fetchMyPlan() {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    if (asta_id && user_uid) {
      off(child(astasquadreRef, asta_id + "/" + user_uid + "/plan"));
      onValue(
        child(astasquadreRef, asta_id + "/" + user_uid + "/plan"),
        (snapshot) => {
          let val = snapshot.val();
          store.commit(types.PLAN_SET, val);
        }
      );
    }
  }

  fetchMyCuori() {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    if (asta_id && user_uid) {
      off(child(astaCuoriRef, asta_id + "/" + user_uid));
      onValue(child(astaCuoriRef, asta_id + "/" + user_uid), (snapshot) => {
        store.commit(types.CUORI_SET, snapshot.val() || {});
      });
    }
  }

  setCuoriCalciatore(calciatore_id, cuori) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();

    if (!asta_id || !user_uid || !calciatore_id) {
      return Promise.reject("Error setCuoriCalciatore");
    }

    const cuoriRef = child(
      astaCuoriRef,
      asta_id + "/" + user_uid + "/" + calciatore_id
    );

    if (!cuori || parseInt(cuori) === 0) {
      return remove(cuoriRef);
    }

    return set(cuoriRef, parseInt(cuori));
  }

  getAstaSquadre(asta_id) {
    return get(child(astasquadreRef, asta_id)).then((snapshot) => {
      let squadre = snapshot.val();
      return squadre;
    });
  }

  getSquadra(asta_id, squadra_id) {
    return get(child(astasquadreRef, asta_id + "/" + squadra_id)).then(
      (snapshot) => {
        return snapshot.val();
      }
    );
  }

  getSquadre() {
    let asta_id = store.getters.asta_id;
    return get(child(astasquadreRef, asta_id)).then((snapshot) => {
      let squadre = snapshot.val();
      return squadre;
    });
  }

  fetchAstaLogsLast() {
    let asta_id = store.getters.asta_id;
    const lastChildQuery = query(
      child(astaLogsRef, asta_id),
      orderByKey(),
      limitToLast(1)
    );
    onChildAdded(lastChildQuery, (snapshot) => {
      let log = snapshot.val() || {};
      log.key = snapshot.key;
      store.commit(types.ASTA_LOGS_LAST, log);
      // eccezione per capire quando è stato assegnato un calciatore
      if (log.t == Constants.LOG_TYPE.ASSIGN) {
        const assegnazione = {
          squadra_id: log.sid,
          calciatore_id: log.cid,
          prezzo: log.p,
        };
        this.emit("calciatoreAssegnato", assegnazione);
      }
    });
  }

  setAstaLogsAll(nItems, endAtValue) {
    let asta_id = store.getters.asta_id;
    store.commit(types.ASTA_LOGS_LOADING, true);
    if (endAtValue) {
      let queryRef = query(
        child(astaLogsRef, asta_id),
        orderByKey(),
        limitToLast(nItems + 1),
        endAt(endAtValue)
      );

      get(queryRef).then((snapshot) => {
        let logs = [];
        if (snapshot.exists()) {
          // se nn lo trasformo in array, rischio che vue mi perde l'ordinamento giusto
          snapshot.forEach((childSnapshot) => {
            let log = childSnapshot.val();
            log.key = childSnapshot.key; // aggiungo la key tra i valori per facilitarmi dopo
            logs.unshift(log); // perchè firebase nn me lo da direttamente in ordine inverso
          });
        }
        store.commit(types.ASTA_LOGS_ALL, logs);
        store.commit(types.ASTA_LOGS_LOADING, false);
      }).catch(() => {
        store.commit(types.ASTA_LOGS_LOADING, false);
      });
    } else {
      let queryRef = query(
        child(astaLogsRef, asta_id),
        orderByKey(),
        limitToLast(nItems + 1)
      );
      get(queryRef).then((snapshot) => {
        let logs = [];
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            let log = childSnapshot.val();
            log.key = childSnapshot.key;
            logs.unshift(log);
          });
        }
        store.commit(types.ASTA_LOGS_ALL, logs);
        store.commit(types.ASTA_LOGS_LOADING, false);
      }).catch(() => {
        store.commit(types.ASTA_LOGS_LOADING, false);
      });
    }
  }

  // calciatori
  getCalciatoriOriginal() {
    return get(
      child(calciatoriRef, Config.TORNEO_ID + "/" + Config.ANNO_ID)
    ).then((snapshot) => {
      let calciatori = snapshot.val();
      return calciatori;
    });
  }

  // getListoneConf() {
  //   return get(
  //     child(listoneConfRef, Config.TORNEO_ID + "/" + Config.ANNO_ID)
  //   ).then((snapshot) => {
  //     let listoneConf = snapshot.val();
  //     return listoneConf;
  //   });
  // }

  fetchCalciatoriCustom() {
    let asta_id = store.getters.asta_id;
    off(child(calciatoriCustomRef, asta_id));
    onValue(child(calciatoriCustomRef, asta_id), (snapshot) => {
      let calciatoriCustom = snapshot.val() || {};
      store.commit(types.CALCIATORI_CUSTOM, calciatoriCustom);
    });
  }

  setCalciatoreCustom(calciatore_id, ruolo_id) {
    let asta_id = store.getters.asta_id;
    return set(
      child(calciatoriCustomRef, asta_id + "/" + calciatore_id + "/ID_Ruolo"),
      ruolo_id.toString()
    );
  }

  removeCalciatoreCustom(calciatore_id) {
    let asta_id = store.getters.asta_id;
    return remove(child(calciatoriCustomRef, asta_id + "/" + calciatore_id));
  }

  assegnaCalciatore(id_calciatore, id_squadra, crediti, i = 0) {
    let asta_id = store.getters.asta_id;
    let asta_squadre = store.getters.asta_squadre;

    if (!id_calciatore)
      return Promise.reject("Error assegnaCalciatore id_calciatore");
    if (!id_squadra in asta_squadre)
      return Promise.reject("Error assegnaCalciatore id_squadra");

    let squadra = asta_squadre[id_squadra];

    if (squadra.crediti - parseFloat(crediti) < 0) {
      return Promise.reject("Error crediti insufficienti");
    }

    let updates = {};
    updates["/asta-squadre/" + asta_id + "/" + id_squadra + "/crediti"] =
      squadra.crediti - parseFloat(crediti);
    updates[
      "/asta-squadre/" +
        asta_id +
        "/" +
        id_squadra +
        "/calciatori/" +
        id_calciatore
    ] = {
      p: parseFloat(crediti),
      i: i,
    };

    return new Promise(function (resolve, reject) {
      update(ref(database), updates).then(function () {
        resolve({
          calciatore: id_calciatore,
          squadra: id_squadra,
          crediti: parseFloat(crediti),
        });
      });
    });
  }

  rimuoviCalciatoreAssegnato(id_calciatore, id_squadra) {
    let asta_id = store.getters.asta_id;
    let asta_squadre = store.getters.asta_squadre;

    if (!id_calciatore)
      return Promise.reject("Error rimuoviCalciatoreAssegnato id_calciatore");
    if (!id_squadra in asta_squadre)
      return Promise.reject("Error rimuoviCalciatoreAssegnato id_squadra");

    let squadra = asta_squadre[id_squadra];

    if (!id_calciatore in squadra.calciatori) return Promise.reject("Error");
    let calciatore = squadra.calciatori[id_calciatore];

    let updates = {};
    updates["/asta-squadre/" + asta_id + "/" + id_squadra + "/crediti"] =
      squadra.crediti + parseFloat(calciatore.p);
    updates[
      "/asta-squadre/" +
        asta_id +
        "/" +
        id_squadra +
        "/calciatori/" +
        id_calciatore
    ] = null;

    return update(ref(database), updates);
  }

  modificaCalciatoreAssegnato(id_calciatore, id_squadra, crediti) {
    let asta_id = store.getters.asta_id;
    let asta_squadre = store.getters.asta_squadre;

    if (!id_calciatore)
      return Promise.reject("Error modificaCalciatoreAssegnato id_calciatore");
    if (!id_squadra in asta_squadre)
      return Promise.reject("Error modificaCalciatoreAssegnato id_squadra");

    let squadra = asta_squadre[id_squadra];

    if (!id_calciatore in squadra.calciatori) return Promise.reject("Error");
    let calciatore = squadra.calciatori[id_calciatore];

    let updates = {};
    updates["/asta-squadre/" + asta_id + "/" + id_squadra + "/crediti"] =
      squadra.crediti + parseFloat(calciatore.p) - parseFloat(crediti);
    updates[
      "/asta-squadre/" +
        asta_id +
        "/" +
        id_squadra +
        "/calciatori/" +
        id_calciatore
    ] = {
      p: parseFloat(crediti),
      i: 0,
    };

    return update(ref(database), updates);
  }

  setCreditiExtra(id_squadra, creditiExtra) {
    let asta_id = store.getters.asta_id;
    return set(
      child(astasquadreRef, asta_id + "/" + id_squadra + "/crediti_extra"),
      parseFloat(creditiExtra)
    );
  }

  updatePlan(plan) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    // ma non devo eliminare gli eventuali associati e obiettivi
    let updates = {};
    for (const ruolo_abc in plan) {
      for (const slot in plan[ruolo_abc]) {
        for (const field in plan[ruolo_abc][slot]) {
          const value = plan[ruolo_abc][slot][field];
          updates["/" + ruolo_abc + "/" + slot + "/" + field] = value;
        }
      }
    }
    return update(
      child(astasquadreRef, asta_id + "/" + user_uid + "/plan/"),
      updates
    );
  }

  setPlanAssociato(ruolo_abc, slot, calciatore_id) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    return set(
      child(
        astasquadreRef,
        asta_id +
          "/" +
          user_uid +
          "/plan/" +
          ruolo_abc +
          "/" +
          slot +
          "/associato"
      ),
      calciatore_id
    );
  }

  setSettingsPlanAssociazione(method) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    return set(
      child(
        astasquadreRef,
        asta_id + "/" + user_uid + "/settings/plan/associazione"
      ),
      method
    );
  }

  setSettingsPlanNRuoli(nPDCA, value) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    return set(
      child(
        astasquadreRef,
        asta_id + "/" + user_uid + "/settings/plan/nRuoli" + "/" + nPDCA
      ),
      value
    );
  }

  scartaCalciatore(id_calciatore) {
    if (!id_calciatore)
      return Promise.reject("Error scartaCalciatore id_calciatore");
    return this.scartaCalciatori([id_calciatore]);
  }

  rimuoviCalciatoreScartato(id_calciatore) {
    let asta_id = store.getters.asta_id;
    if (!id_calciatore)
      return Promise.reject("Error rimuoviCalciatoreScartato id_calciatore");
    return remove(child(astascartatiRef, asta_id + "/" + id_calciatore));
  }

  scartaCalciatori(ids) {
    const asta_id = store.getters.asta_id;
    if (!ids.length) return Promise.resolve();
    const updates = {};
    ids.forEach((id) => {
      updates[id] = 1;
    });
    return update(child(astascartatiRef, asta_id), updates);
  }

  rimuoviScartati() {
    let asta_id = store.getters.asta_id;
    return remove(child(astascartatiRef, asta_id));
  }

  // round
  getAstaRound() {
    let asta_id = store.getters.asta_id;
    return get(child(astaroundRef, asta_id)).then((snapshot) => {
      let _round = snapshot.val();
      let round = this.initAstaRound(_round);
      return round;
    });
  }

  initAstaRound(_round) {
    return {
      calciatoreInAsta:
        _round && _round.calciatoreInAsta ? _round.calciatoreInAsta : null,
      speaker: _round && _round.speaker ? _round.speaker : null,
      speakerTimeLeft:
        _round && _round.speakerTimeLeft ? _round.speakerTimeLeft : null,
      offerte: _round && _round.offerte ? _round.offerte : {},
      offerte_ts: _round && _round.offerte_ts ? _round.offerte_ts : {},
      chooser: _round && _round.chooser ? _round.chooser : null,
      step: _round && _round.step ? _round.step : null,
    };
  }

  fetchRound() {
    let asta_id = store.getters.asta_id;
    let astaref = child(astaroundRef, asta_id);

    off(child(astaref, "calciatoreInAsta"));
    onValue(child(astaref, "calciatoreInAsta"), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        calciatoreInAsta: _val,
      });
      this.emit("calciatoreInAsta");
    });

    off(child(astaref, "speaker"));
    onValue(child(astaref, "speaker"), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        speaker: _val,
      });
      this.emit("speaker");
    });

    off(child(astaref, "speakerTimeLeft"));
    onValue(child(astaref, "speakerTimeLeft"), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        speakerTimeLeft: _val,
      });
    });

    off(child(astaref, "chooser"));
    onValue(child(astaref, "chooser"), (snapshot) => {
      let _val = snapshot.val() || null;
      store.commit(types.ROUND_UPD, {
        chooser: _val,
      });
    });

    off(child(astaref, "offerte"));
    onValue(child(astaref, "offerte"), (snapshot) => {
      let _val = snapshot.val() || {};
      store.commit(types.ROUND_UPD, {
        offerte: _val,
      });
      this.emit("offerte");
    });

    off(child(astaref, "offerte_ts"));
    onValue(child(astaref, "offerte_ts"), (snapshot) => {
      let _val = snapshot.val() || {};
      store.commit(types.ROUND_UPD, {
        offerte_ts: _val,
      });
    });

    off(child(astaref, "step"));
    onValue(child(astaref, "step"), (snapshot) => {
      let _val = snapshot.val();
      store.commit(types.ROUND_UPD, {
        step: _val,
      });
    });
  }

  fetchOnline() {
    let asta_id = store.getters.asta_id;
    if (asta_id) {
      off(child(astaonlineRef, asta_id));
      onValue(child(astaonlineRef, asta_id), (snapshot) => {
        let _val = snapshot.val() || {};
        store.commit(types.ONLINE_SET, _val);
        this.emit("fetchedOnline");
      });
    }
  }

  initPresence() {
    let asta_id = store.getters.asta_id;
    let user_uid = store.state.user.user_uid;
    let presenceRef = child(astaonlineRef, asta_id + "/" + user_uid);
    return new Promise((resolve, reject) => {
      get(presenceRef).then((snapshot) => {
        // se presence nn esiste o è reset...
        if (
          snapshot.val() === null ||
          snapshot.val() === Constants.PRESENCE_STATES.RESET
        ) {
          // ... allora mettiti in ascolto su connectedRef
          off(connectedRef);
          onValue(connectedRef, (snap) => {
            // se true vuol dire che sono online
            if (snap.val() === true) {
              // ma prima di "set (presenceRef, ONLINE)"...
              // ...dire al server come comportarsi in caso di disconnessione
              onDisconnect(presenceRef)
                .remove()
                .then(function () {
                  // The promise returned from .onDisconnect().remove() will
                  // resolve as soon as the server acknowledges the onDisconnect()
                  // request, NOT once we've actually disconnected:
                  // https://firebase.google.com/docs/reference/js/firebase.database.OnDisconnect

                  // We can now safely set ourselves as 'online' knowing that the
                  // server will mark us as offline once we lose connection.
                  set(presenceRef, Constants.PRESENCE_STATES.ONLINE);
                });
            } else {
              set(presenceRef, Constants.PRESENCE_STATES.OFFLINE);
            }
          });
          resolve();
        } else {
          // senno mostra pagina di reset
          reject(new ErrorSessionExist());
        }
      });
    });
  }

  initIdle() {
    let asta_id = store.getters.asta_id;
    let user_uid = store.state.user.user_uid;
    let presenceRef = child(astaonlineRef, asta_id + "/" + user_uid);
    return new idleJs({
      idle: 10000, // idle time in ms
      // events that will trigger the idle resetter
      events: ["mousemove", "touchstart"],
      // callback function to be executed after idle time
      onIdle: () => {
        // set(presenceRef, Constants.PRESENCE_STATES.AWAY);
      },
      // callback function to be executed after back form idleness
      onActive: () => {
        set(presenceRef, Constants.PRESENCE_STATES.ONLINE);
      },
      onHide: () => {
        set(presenceRef, Constants.PRESENCE_STATES.AWAY);
      },
      onShow: () => {
        set(presenceRef, Constants.PRESENCE_STATES.ONLINE);
      },
      keepTracking: true, // set it to false of you want to track only once
      startAtIdle: false, // set it to true if you want to start in the idle state
    });
  }

  resetPresence(asta_id) {
    let user_uid = authentication.getUserId();
    let presenceRef = child(astaonlineRef, asta_id + "/" + user_uid);
    return set(presenceRef, Constants.PRESENCE_STATES.RESET);
  }

  async leavePresence() {
    const presenceRef = child(astaonlineRef, store.getters.asta_id + "/" + authentication.getUserId());
    off(connectedRef);
    await onDisconnect(presenceRef).cancel();
    await remove(presenceRef);
  }

  updateSquadreActive(squadre, val) {
    let asta_id = store.getters.asta_id;
    let updates = {};
    if (_.size(squadre) > 0) {
      for (const squadra of Object.values(squadre)) {
        updates["/" + squadra.id + "/active"] = val;
      }
      return update(child(astasquadreRef, asta_id), updates);
    }
  }

  resetRound(chooser, stopAsta = false) {
    return this.setChooser(chooser) // è meglio che sia al primo posto così alla fine del round nn compare per un attimo al chooser di prima
      .then(this.setCalciatoreInAsta(null))
      .then(this.setStep(null))
      .then(this.setOfferte({}))
      .then(this.setSpeaker(null))
      .then(this.setSpeakerTimeLeft(null))
      .then(() => {
        if (stopAsta) {
          this.setSetting("status", Constants.ASTA_STATUS.NOT_RUNNING);
        }
      });
  }

  setCalciatoreInAsta(id_calciatore) {
    let asta_id = store.getters.asta_id;
    return set(
      child(astaroundRef, asta_id + "/calciatoreInAsta"),
      id_calciatore
    );
  }

  initRound(id_calciatore, asta_mode) {
    let user_uid = authentication.getUserId();
    let prossimoSpeaker = asta_mode == Constants.ASTA_MODE.POKER;
    let offerte = this.initOfferte(id_calciatore, asta_mode);
    let speaker = prossimoSpeaker
      ? this.prossimoSpeaker(user_uid, offerte)
      : null;
    return this.setOfferte(offerte).then(this.setSpeaker(speaker));
  }

  // si controlla se si può acquistare (crediti, ruolo, club)
  // se nn si può acquistare metto PASSO
  // altrimenti INIT
  initOfferte(id_calciatore, asta_mode) {
    let user_uid = authentication.getUserId();
    let calciatore = store.getters.calciatori[id_calciatore];
    let chooser_mode = store.getters.asta_settings.ch_mode;
    let regole_lega = store.state.asta.info.lega;
    let asta_squadre = store.getters.asta_squadre;
    let asta_squadre_attive = store.getters.asta_squadre_active;
    let base_asta = store.getters.asta_settings.base_asta;
    let offerta_min = Helpers.minOfferta(base_asta, calciatore);
    let offerta_auto =
      store.getters.asta_settings.offerta_auto &&
      chooser_mode !== Constants.CHOOSER_MODE.ADMIN &&
      asta_mode != Constants.ASTA_MODE.BUSTA_CHIUSA;
    // se c'è offerta contestuale, devo fare il check di chi potrà offrire +1 rispetto alla minima
    let crediti_min = parseFloat(offerta_auto ? offerta_min + 1 : offerta_min);
    let _offerte = {};
    for (let sq of asta_squadre_attive) {
      let squadra = asta_squadre[sq.id];
      if (Helpers.canJoinRound(regole_lega, squadra, calciatore, crediti_min)) {
        _offerte[sq.id] = Constants.OFFERTA.INIT;
      } else {
        _offerte[sq.id] = Constants.OFFERTA.PASSO;
      }
    }
    // sovrascivi la mia offerta (perchè si da per scontato che se l'ho scelto io, potevo sceglierlo)
    if (offerta_auto) {
      _offerte[user_uid] = offerta_min;
    }
    return _offerte;
  }

  // prossimoSpeaker (= true solo in Poker) -> calcola prossimo speaker
  // noCheck (= true solo in BustaChiusa e Selvaggia)-> disattiva check su offerte altri giocatori
  // withTimestamp (PUO' essere true solo in BustaChiusa) ->
  setOfferta(
    off,
    prossimoSpeaker = true,
    noCheck = false,
    withTimestamp = false
  ) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    let offerta = parseFloat(off);

    // offerte prima di quella appane fatta
    let offertePre = store.state.asta.round.offerte;

    // offerte con quella appena fatta
    let offertePost = _.cloneDeep(offertePre);
    offertePost[user_uid] = offerta;

    // se passo nn devo controllare le altre offerte (checkOfferte)
    // in BustaChiusa e Selvaggia nn devo controllare le altre offerte
    if (offerta === Constants.OFFERTA.PASSO || noCheck) {
      // SALVO TIMESTAMP OFFERTA SOLO SE DIVERSA DA PASSO (SERVE IN BUSTA CHIUSA)
      if (withTimestamp && offerta !== Constants.OFFERTA.PASSO) {
        let speaker = prossimoSpeaker
          ? this.prossimoSpeaker(user_uid, offertePost)
          : null;
        let updates = {};
        updates["/asta-round/" + asta_id + "/offerte/" + user_uid] = offerta;
        updates["/asta-round/" + asta_id + "/offerte_ts/" + user_uid] =
          serverTimestamp();

        return update(ref(database), updates).then(() => {
          this.setSpeaker(speaker);
        });
      } else {
        let speaker = prossimoSpeaker
          ? this.prossimoSpeaker(user_uid, offertePost)
          : null;
        return set(
          child(astaroundRef, asta_id + "/offerte/" + user_uid),
          offerta
        ).then(this.setSpeaker(speaker));
      }
    } else {
      // Se ho offerto
      // "offerte" verrà sovrascritto con PASSO se nn si può offrire +1 rispetto all'"offerta" attuale
      let offertePostCheck = this.checkOfferte(user_uid, offerta, offertePost);
      // => in questo modo eviterò di dare lo speaker a chi nn potrà offrire +1
      let speaker = prossimoSpeaker
        ? this.prossimoSpeaker(user_uid, offertePostCheck)
        : null;
      // salvo tutte insieme
      return this.setOfferte(offertePostCheck).then(this.setSpeaker(speaker));
    }
  }

  // si controlla se si può acquistare (crediti)
  // se nn si può acquistare metto PASSO
  // altrimenti lascio quello che c'era
  checkOfferte(squadra_id, offerta_corrente, offerte) {
    let _offerte = _.cloneDeep(offerte);
    let asta_squadre = store.getters.asta_squadre;
    let asta_squadre_attive = store.getters.asta_squadre_active;
    for (let sq of asta_squadre_attive) {
      let squadra = asta_squadre[sq.id];
      // importante: devo saltare la squadra che ha fatto l'offerta
      if (
        squadra_id != sq.id &&
        !Helpers.canRilanciare(squadra, parseFloat(offerta_corrente) + 1)
      ) {
        _offerte[sq.id] = Constants.OFFERTA.PASSO;
      }
    }
    return _offerte;
  }

  setPasso(user_uid, prossimoSpeaker) {
    let asta_id = store.getters.asta_id;
    let speaker = prossimoSpeaker
      ? this.prossimoSpeaker(user_uid, store.state.asta.round.offerte)
      : null;
    return set(
      child(astaroundRef, asta_id + "/offerte/" + user_uid),
      Constants.OFFERTA.PASSO
    ).then(this.setSpeaker(speaker));
  }

  setStep(step) {
    let asta_id = store.getters.asta_id;
    return set(child(astaroundRef, asta_id + "/step"), step);
  }

  setOfferte(offerte) {
    let asta_id = store.getters.asta_id;
    return set(child(astaroundRef, asta_id + "/offerte"), offerte);
  }

  setSpeaker(speaker) {
    let asta_id = store.getters.asta_id;
    return set(child(astaroundRef, asta_id + "/speaker"), speaker);
  }

  setSpeakerTimeLeft(timeLeft) {
    let asta_id = store.getters.asta_id;
    return set(child(astaroundRef, asta_id + "/speakerTimeLeft"), timeLeft);
  }

  setChooser(chooser) {
    let asta_id = store.getters.asta_id;
    return set(child(astaroundRef, asta_id + "/chooser"), chooser);
  }

  prossimoSpeaker(speakerCorrente, offerte) {
    // viene chiamato solo in astaPoker

    let squadre = store.getters.asta_squadre_active;

    let speakers = Utils.rotateArray(_.map(squadre, "id"), speakerCorrente);

    let prossimo = null;

    _.each(speakers, (squadra_id) => {
      // se squadra_id ha fatto offerta e offerta != passo
      if (_.has(offerte, squadra_id)) {
        if (offerte[squadra_id] !== Constants.OFFERTA.PASSO) {
          prossimo = squadra_id;
          return false;
        }
      } else {
        prossimo = squadra_id;
        return false;
      }
    });
    let vincente = Helpers.vincenteUnicoAssegnabile(offerte);

    // se prossimo prossimo == Vincente allora non ci sono altri speaker, quindi restituisci null
    if (prossimo && vincente && prossimo == vincente.squadra_id) {
      prossimo = null;
    }

    return prossimo;
  }

  prossimoStep(offertaVincente) {
    let offerte = _.cloneDeep(store.state.asta.round.offerte);
    var offerte_vincenti = _.sumBy(_.values(offerte), (i) =>
      i === offertaVincente ? 1 : 0
    );

    for (let sqid in offerte) {
      if (offerte[sqid] === offertaVincente) {
        if (offerte_vincenti > 1) {
          offerte[sqid] = Constants.OFFERTA.INIT;
        }
      } else {
        offerte[sqid] = Constants.OFFERTA.PASSO;
      }
    }

    if (offerte_vincenti > 1) {
      return this.setOfferte(offerte).then(() =>
        this.setStep({
          type: Constants.ROUND_STEP.OFFERTE,
          min_offerta: offertaVincente,
        })
      );
    } else {
      return this.setOfferte(offerte);
    }
  }

  addMessage(msg, cb) {
    let asta_id = store.getters.asta_id;
    let user_uid = authentication.getUserId();
    const newRef = push(child(astamessagesRef, asta_id));
    set(newRef, {
      id: user_uid,
      text: msg,
      type: Constants.MESSAGE_TYPE.CHAT,
      ts: serverTimestamp(),
    }).then(cb());
  }

  fetchMessages() {
    let asta_id = store.getters.asta_id;
    if (asta_id) {
      var newItems = false;

      off(child(astamessagesRef, asta_id));
      const queryRef = query(child(astamessagesRef, asta_id), limitToLast(20));
      onChildAdded(queryRef, (snapshot) => {
        if (!newItems) return;
        var message = snapshot.val();
        store.commit(types.MESSAGES_ADD, message);
        this.emit("newMessage", message);
      });

      get(queryRef).then((snapshot) => {
        newItems = true;
        var messages = snapshot.val();
        store.commit(types.MESSAGES_SET, _.values(messages));
      });
    }
  }

  fetchScartati(cb) {
    let asta_id = store.getters.asta_id;
    if (asta_id) {
      off(child(astascartatiRef, asta_id));
      onValue(child(astascartatiRef, asta_id), function (snapshot) {
        // verifico esistenza mia squadra
        let _scartati = snapshot.val() || {};

        store.commit(types.SCARTATI_SET, _scartati);

        if (typeof cb === "function") cb();
      });
    }
  }

  setSetting(key, value) {
    let asta_id = store.getters.asta_id;
    return set(child(astaRef, asta_id + "/settings/" + key), value);
  }

  setSettings(settings) {
    let asta_id = store.getters.asta_id;
    return update(child(astaRef, asta_id + "/settings"), settings);
  }

  async setLegaSettings(legaSettings) {
    let asta_id = store.getters.asta_id;
    if (Config.STANDALONE && legaSettings.nRuoli) {
      const [legaSnapshot, squadreSnapshot, tipoRuoliSnapshot] = await Promise.all([
        get(child(astaRef, asta_id + "/lega")),
        get(child(astasquadreRef, asta_id)),
        get(child(astaRef, asta_id + "/settings/tipo_ruoli")),
      ]);
      validateRosaLimits(
        (legaSnapshot.val() || {}).nRuoli || {},
        legaSettings.nRuoli,
        squadreSnapshot.val() || {},
        store.getters.calciatori || {},
        tipoRuoliSnapshot.val() || Constants.TIPO_RUOLI.CLASSIC
      );
      legaSettings = {
        ...legaSettings,
        nRuoli: { ...((legaSnapshot.val() || {}).nRuoli || {}), ...legaSettings.nRuoli },
      };
    }
    return update(child(astaRef, asta_id + "/lega"), legaSettings);
  }

  updateCounter() {
    let asta_id = store.getters.asta_id;

    return new Promise(function (resolve, reject) {
      if (store.state.asta.info.premium) return resolve();

      // Run a transaction
      runTransaction(child(astaRef, asta_id + "/counter"), (currentData) => {
        // Modify the current data
        if (currentData === null) {
          // Handle the case when the data doesn't exist
          return 1; // Set the new data value
        } else {
          // Handle the case when the data exists
          // Modify the current data and return the modified value
          const newData = currentData - 1;
          return newData; // Set the modified data value
        }
      })
        .then((transactionResult) => {
          // Handle the transaction result
          return resolve();
        })
        .catch((error) => {
          // Handle any errors that occurred during the transaction
          console.error("Transaction failed:", error);
          return reject();
        });
    });
  }

  pushAstaLog(log) {
    let asta_id = store.getters.asta_id;
    const newRef = push(child(astaLogsRef, asta_id));
    return set(newRef, {
      ...log,
      ts: serverTimestamp(),
    });
  }

  addAstaToUser(anno_id, uid, torneo_id, asta_id) {
    return set(
      child(userAstaRef, anno_id + "/" + uid + "/" + torneo_id + "/" + asta_id),
      1
    );
  }

  addToAstaBasic(torneo_id, anno_id, asta_id, astaBasic) {
    return set(
      child(astaBasicRef, torneo_id + "/" + anno_id + "/" + asta_id),
      astaBasic
    );
  }

  getUserAsteId(uid) {
    return get(
      child(userAstaRef, Config.ANNO_ID + "/" + uid + "/" + Config.TORNEO_ID)
    ).then((snapshot) => {
      let output = [];
      // se nn lo trasformo in array, rischio che vue mi perde l'ordinamento giusto
      snapshot.forEach((childSnapshot) => {
        output.unshift(childSnapshot.key); // perchè firebase nn me lo da direttamente in ordine inverso
      });
      return output;
    });
  }
}

export default new Asta();
